// Define what main theme will look like
export const theme = {
  Amaranth_Red: "#DA1A32",
  Black: "#000",
  Bright_Gray: "#EDEDED",
  Dark_Silver: "#717171",
  Dark_Cornflower_Blue: "#1F4491",
  Eerie_Black: "#1C1C1C",
  Honolulu_Blue: "#0067B1",
  Lotion: "#FBFBFB",
  Madder_Lake: "#D0343E",
  Maximum_Yellow_Red: "#F3BE50",
  Onyx: "#393939",
  Silver_Sand: "#C6C6C6",
  White: "#FFF",
  RGBA_01: "0,0,0",
  RGB_Background_01: "255,255,255",
  Primary_600: "#5630B5",
  Neutral_900: "#0E1015",
  Dark_Light: "#D9D9D980",
  Gradients_04:
    "linear-gradient(75deg, #6E66FF 3.44%, #7163FB 17.97%, #7C5BF1 31.7%, #8F4EE1 44.61%, #A83CC9 56.72%, #CA24AB 68.83%, #F20887 80.94%, #FF007C 84.17%)",
  Gradients_01: "linear-gradient(180deg, #FF007C 0%, #6E66FF 100%)",
};
